import React from 'react';
import styles from './AdvisorTypeBadge.module.css';

// Colour-coded dot, only used by the `status` variant (presence in the messages header).
// Advisor-type badges no longer carry a dot.
const getStatusDotColor = (advisorType) => {
  const lowerType = (advisorType || '').toLowerCase();

  if (lowerType.includes('mortgage') || lowerType.includes('hypo')) return '#2E90FA';
  if (lowerType.includes('insurance') || lowerType.includes('dommage') || lowerType.includes('assurance')) return '#17B26A';
  if (lowerType.includes('advisor') || lowerType.includes('financ') || lowerType.includes('sécurité') || lowerType.includes('securite')) return '#6366F1';
  return '#717680';
};

/**
 * `brand` (default) — the advisor cabinet pill: brand-blue outline, 10% blue fill, no dot.
 * `status`          — the older white pill with a coloured dot, kept for the messages
 *                     header where the dot signals presence rather than a category.
 */
const AdvisorTypeBadge = ({ type, variant = 'brand', className = '', ...props }) => {
  const isStatus = variant === 'status';

  return (
    <div
      className={`${styles.badge} ${isStatus ? styles.statusBadge : styles.brandBadge} ${className}`}
      {...props}
    >
      {isStatus && (
        <div
          className={styles.dot}
          style={{ backgroundColor: getStatusDotColor(type) }}
        />
      )}
      <span className={styles.text}>
        {type}
      </span>
    </div>
  );
};

export default AdvisorTypeBadge;
